<!-- eslint-disable vue/no-v-html -->

<template>
  <CheckoutModal v-model="isModalActive">
    <template v-slot:title>
      {{ title }}
    </template>

    <ModalOptionCheckbox
      v-model="option"
      :modal-option-title="checkoutOptionTitle"
      :modal-option-description="checkoutOptionDescription"
      :optional-title="optionalTitle"
      :value-label="valueLabel"
      class="checking-files-modal__checkbox-wrapper"
    />

    <template v-slot:action-toolbar>
      <ModalSubmitButton
        :redirect-url="redirectUrl"
        :submit-button-label="submitButtonLabel"
        @click="submit"
      />
    </template>
  </CheckoutModal>
</template>

<script>
import CheckoutModal from './CheckoutModal';
import ModalOptionCheckbox from '../Modals/ModalOptionCheckbox';
import ModalSubmitButton from '../Modals/ModalSubmitButton';

export default {
  name: 'CheckingFilesModal',
  components: {
    ModalSubmitButton,
    ModalOptionCheckbox,
    CheckoutModal,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    checkoutOptionTitle: {
      type: String,
      required: true,
    },
    checkoutOptionDescription: {
      type: String,
      required: true,
    },
    optionalTitle: {
      type: String,
      required: true,
    },
    valueLabel: {
      type: String,
      required: true,
    },
    submitButtonLabel: {
      type: String,
      default: undefined,
    },
    submitUrl: {
      type: String,
      required: true,
    },
    redirectUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      option: null,
    };
  },
  computed: {
    isModalActive: {
      get() {
        return window.modalStateObservable.isCheckingFilesModalActive;
      },
      set(v) {
        window.modalStateObservable.isCheckingFilesModalActive = v;
      },
    },
  },
  methods: {
    submit(event) {
      if (this.option) {
        event.preventDefault();

        const form = document.createElement('form');
        const csrfToken = document.head.querySelector(
          'meta[name="csrf-token"]'
        ).content;

        form.method = 'post';
        form.action = `${this.submitUrl}?redirectToCheckout=1&_token=${csrfToken}`;

        document.body.appendChild(form);
        form.submit();
      }
    },
  },
};
</script>
